import { COLORS } from 'consts/colors'
import styled from 'styled-components'

export const DropdownContainer = styled.div`
  width: 100%;
`

export const DropdownLabel = styled.p`
  font-size: 12px;
  font-weight: 600;
  color: ${COLORS.secondaryDark};
  margin-bottom: 8px;
`
